import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import "./Styles/global.module.css";
import About from "./Pages/About";
import Dots from "./Components/Dots";
import Projects from "./Pages/Projects";
import Contact from "./Pages/Contact";
import { PortfolioProvider } from "./Context/Portfolio";

const App = () => {
  return (
    <PortfolioProvider>
      <BrowserRouter>
        <Navbar />
        <Dots />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/projects" element={<Projects />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/about/*" element={<About />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </PortfolioProvider>
  );
};

export default App;
